import * as React from 'react';

import Text from 'crehana-ui/Text';

import unescapeChars from 'Shared/StringParser/unescapeChars';

import { CourseCardProps } from 'Jsx/Shared/CourseCardV3/types';

const Professor: React.FC<Partial<CourseCardProps>> = props => {
  const { professor } = props;

  return (
    <div className="ProfessorComponent mt-8 flex" style={{ minHeight: 40 }}>
      <Text type="body4" color="gray-dark">
        {`Por ${professor ? unescapeChars(professor.fullName) : 'crehana'}`}
      </Text>
    </div>
  );
};

export default Professor;
